import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import MPageImage from "Utils/Helpers/MPageImage";
import AddSocialData from "./components/Add";
import TableSocialData from "./components/Table";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setSocialData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_socials } from "http/components/Social";

export default function SocialData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [image, setImage] = useState(null);
  const { social } = useSelector((state) => ({
    social: state.mngr.social,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (social) getData();
  }, [social]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_socials(81711);
    if (CheckApiStatus(response)) {
      setData(response.data.infos);
      setImage(response.data.image);
    }
    dispatch(setSocialData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 item size={{ lg: 5, md: 6, sm: 6, xs: 12 }}>
          <MPaper
            label={"New Social"}
            content={<AddSocialData />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
          <MPaper
            label={"Page Image"}
            content={<MPageImage image={image} page={"social"} />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ xs: 12 }}>
          <MPaper
            label={"Socials list"}
            content={<TableSocialData data={data} />}
            defaultExpanded={true}
          />
        </Grid2>
      </Grid2>
    </>
  );
}
